(function () {
  const SPEED = 0.6;

  function setup(section) {
    const original =
      section.querySelector('[data-testid="resource-list-grid"]') ||
      section.querySelector('.resource-list') ||
      section.querySelector('.section-resource-list__content');

    if (!original) return;

    const items = Array.from(original.querySelectorAll('.resource-list__item'));
    if (items.length < 2) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'mec-auto-marquee';

    const scroller = document.createElement('div');
    scroller.className = 'mec-auto-marquee__scroller';

    const track = document.createElement('div');
    track.className = 'mec-auto-marquee__track';

    items.forEach((it) => {
      const box = document.createElement('div');
      box.className = 'mec-auto-marquee__item';
      box.appendChild(it);
      track.appendChild(box);
    });

    items.forEach((it) => {
      const clone = it.cloneNode(true);
      const box = document.createElement('div');
      box.className = 'mec-auto-marquee__item';
      box.appendChild(clone);
      track.appendChild(box);
    });

    scroller.appendChild(track);
    wrapper.appendChild(scroller);
    original.replaceWith(wrapper);

    function tick() {
      scroller.scrollLeft += SPEED;
      const half = track.scrollWidth / 2;
      if (scroller.scrollLeft >= half) {
        scroller.scrollLeft -= half;
      }
      requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
  }

  document.querySelectorAll('[data-testid="product-list"]').forEach(setup);
})();